import request from '@/common/request'
import { commonParams } from '@/api/config'
import { getToken } from '@/common/auth'

export function GetFunTree(UserID) {
  const loginKey = getToken()
  return request({
    url: './query/QueryFunTree',
    method: 'post',
    data: {
      loginKey,
      UserID
    }
  })
}

export function GetFunList(UserID) {
  const loginKey = getToken()
  return request({
    url: './query/QueryFunList',
    method: 'post',
    data: {
      loginKey,
      UserID
    }
  })
}

export function GetFunNameList(UserID) {
  const loginKey = getToken()
  return request({
    url: './query/QueryFunNameList',
    method: 'post',
    data: {
      loginKey,
      UserID
    }
  })
}

export function GetEnterpriList(EID) {
  const loginKey = getToken()
  return request({
    url: './query/QueryEnterpriList',
    method: 'post',
    data: {
      loginKey,
      EID
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js